"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KnockPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _KnockTypes = require("../../constants/KnockTypes");
var KnockPropTypes = exports.KnockPropTypes = _propTypes["default"].shape({
  _id: _propTypes["default"].string.isRequired,
  presenterId: _propTypes["default"].string,
  name: _propTypes["default"].string,
  type: _propTypes["default"].oneOf([_KnockTypes.SCREENSHARE, _KnockTypes.PRESENTER]),
  sources: _propTypes["default"].array
});